<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_iii"></a><a id="title"></a></p>
<h1 class="h1">Dreaming in the World’s Religions</h1>
<p class="subtitle"><em>A Comparative History</em></p>
<p class="author">Kelly Bulkeley</p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?55cf8ec4